import React, { useState } from "react";
import {
  Box,
  IconButton,
  TextField,
  Button,
  Typography,
  Paper,
} from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import { useSpring, animated } from "react-spring";

const SignUp = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  // Animation for the chat box
  const animation = useSpring({
    transform: isOpen ? "translateY(0%)" : "translateY(100%)",
    opacity: isOpen ? 1 : 0,
  });

  const toggleChat = () => setIsOpen(!isOpen);

  const handleSend = () => {
    if (input.trim()) {
      setMessages((prev) => [...prev, { text: input, sender: "user" }]);
      setInput("");
    }
  };

  return (
    <Box sx={{ position: "fixed", bottom: 16, right: 16, zIndex: 1000 }}>
      {/* Chat Icon Button */}
      {!isOpen && (
        <IconButton
          color="primary"
          onClick={toggleChat}
          sx={{ backgroundColor: "white", boxShadow: 3 }}
        >
          <ChatBubbleOutlineIcon />
        </IconButton>
      )}

      {/* Chat Box */}
      {isOpen && (
        <animated.div style={animation}>
          <Paper
            elevation={6}
            sx={{
              width: 300,
              height: 400,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              p: 2,
              boxShadow: 4,
              borderRadius: 2,
            }}
          >
            {/* Header */}
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h6">Chat</Typography>
              <IconButton onClick={toggleChat}>
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Messages Area */}
            <Box
              sx={{
                flexGrow: 1,
                overflowY: "auto",
                my: 2,
                px: 1,
                backgroundColor: "#f9f9f9",
                borderRadius: 1,
              }}
            >
              {messages.map((message, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: message.sender === "user" ? "flex-end" : "flex-start",
                    mb: 1,
                  }}
                >
                  <Typography
                    sx={{
                      backgroundColor: message.sender === "user" ? "#1976d2" : "#e0e0e0",
                      color: message.sender === "user" ? "white" : "black",
                      p: 1,
                      borderRadius: 2,
                      maxWidth: "80%",
                      wordWrap: "break-word",
                    }}
                  >
                    {message.text}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Input Area */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                placeholder="Type a message..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                sx={{ mr: 1 }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSend}
                endIcon={<SendIcon />}
              >
                Send
              </Button>
            </Box>
          </Paper>
        </animated.div>
      )}
    </Box>
  );
};

export default SignUp;
